import { API_BASE_URL } from "@/config";
import SearchSelect from '../search_select/SearchSelect.vue';
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'QualificationForm',
    components: {
        SearchSelect
    },
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                first_names: '',
                surname: '',
                id_number: '',
                qualification: '',
                institution_name: '',
                selected_year: ''
            },
            error: '',
            json_data: {},
            years: Array.from({ length: 75 }, (_, i) => new Date().getFullYear() - i)
        };
    },
    emits: ['service_status_complete'],
    methods: {
        handle_submit() {
            if (!this.form.first_names) {
                this.error = 'First names are required';
                this.showError('Error', this.error);
                return;
            }
            if (!this.form.surname) {
                this.error = 'Surname is required';
                this.showError('Error', this.error);
                return;
            }
            if (!this.form.id_number) {
                this.error = 'ID number is required';
                this.showError('Error', this.error);
                return;
            }
            if (!/^\d+$/.test(this.form.id_number)) {
                this.error = 'ID number must be numeric';
                this.showError('Error', this.error);
                return;
            }
            if (!this.form.qualification) {
                this.error = 'Qualification is required';
                this.showError('Error', this.error);
                return;
            }
            if (!this.form.institution_name) {
                this.error = 'Institution name is required';
                this.showError('Error', this.error);
                return;
            }
            if (!this.form.selected_year) {
                this.error = 'Year is required';
                this.showError('Error', this.error);
                return;
            }
            const TOKEN = localStorage.getItem('token');
            const QUALIFICATION_CHECK_API = `${API_BASE_URL}/verify_api/instant_verify_api/qualification_check/`;

            this.error = '';

            $.ajax({
                url: QUALIFICATION_CHECK_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    first_names: this.form.first_names,
                    surname: this.form.surname,
                    id_number: this.form.id_number,
                    qualification: this.form.qualification,
                    institution_name: this.form.institution_name,
                    qualification_year: this.form.selected_year
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Qualification Check ran successfully', 3000);
                    this.$emit('service_status_complete');
                },
                error: (error) => {
                    Swal.close();
                    this.showError('Error', error.responseJSON.detail);
                }
            });
        }
    }
};
